/**
 * 로그인 세션이 살아 있는지 주기적으로 확인하는 역할만 맡는 컴포넌트.
 *
 * `pages/_app.tsx` 에서 앱 전체에 한 번만 올려 둔다. 화면에 아무것도 그리지 않고
 * `useSessionHeartbeat` 를 실행하는 것이 전부다. 학생 앱은 한 계정을 한 기기에서만
 * 쓰게 하는 정책이 있어서, 다른 곳에서 같은 계정으로 로그인하면 이 확인을 통해 알아챈다.
 *
 * 주의: 화면 요소가 아니므로 특정 페이지 안으로 옮기면 안 된다.
 * 그 페이지를 벗어나는 순간 세션 확인이 멈춘다.
 */
import { useSessionHeartbeat } from "@/hooks/useSessionHeartbeat";

/** 세션 확인 타이머만 켜 두는 컴포넌트. 그리는 것이 없어 항상 null 을 반환한다. */
export default function SessionManager() {
    useSessionHeartbeat();
    return null;
}
